var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-problem-location" },
    [
      _c(
        "div",
        { staticClass: "c-form__group" },
        [
          _vm.showIsAtProperty
            ? _c("radio-group", {
                attrs: {
                  id: "isAtProperty",
                  label: _vm.isProblemAtAddressLabel
                },
                on: { change: _vm.problemAtAddressChange }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showOutOfPropertyLookup
        ? _c(
            "div",
            [
              _vm.locateProblemOutOfPropertyTitle
                ? _c("h3", { staticClass: "c-problem-location__title" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.locateProblemOutOfPropertyTitle) +
                        "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.locateProblemOutOfPropertyDesc
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.locateProblemOutOfPropertyDesc)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("property-lookup", {
                key: "addressLookup",
                attrs: {
                  id: "addressLookup",
                  lookupFormatError: _vm.postcodeFormatError,
                  lookupLabel: _vm.lookupPostcodeLabel,
                  searchButton: _vm.searchButtonLabel,
                  customersOnly: _vm.customersOnly,
                  notListedError: _vm.postcodeNotListed,
                  notAllowedError: _vm.postcodeNotAllowed
                },
                on: {
                  selectedAddress: _vm.updateAddress,
                  locationValid: _vm.setLocationValid,
                  onSubmit: _vm.propertyLookupSubmit
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showProblemAtProperty
        ? _c(
            "div",
            [
              _vm.locateProblemAtPropertyTitle
                ? _c("h3", { staticClass: "c-problem-location__title" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.locateProblemAtPropertyTitle) +
                        "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.locateProblemAtPropertyDesc
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.locateProblemAtPropertyDesc)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-form__group" },
                [
                  _c("radio-list", {
                    attrs: {
                      id: "locationProblemOptions",
                      options: _vm.locateProblemOptions,
                      label: _vm.locateProblemAtPropertyLabel
                    },
                    on: { change: _vm.locationProblemChange }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showCustomerReferenceLookup
                ? _c("property-lookup", {
                    key: "customerReferenceLookup",
                    attrs: {
                      id: "customerReferenceLookup",
                      lookupFormatError: _vm.customerReferenceFormatError,
                      lookupLabel: _vm.lookupCustomerReferenceLabel,
                      searchButton: _vm.searchButtonLabel,
                      isCustomerReference: true,
                      customersOnly: _vm.customersOnly,
                      notListedError: _vm.customerReferenceNotListed,
                      notAllowedError: _vm.customerReferenceNotAllowed
                    },
                    on: {
                      selectedAddress: _vm.updateAddress,
                      locationValid: _vm.setLocationValid,
                      onSubmit: _vm.propertyLookupSubmit,
                      onLookUpValue: _vm.customerRefenceUpdated
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPropertyLookup
                ? _c("property-lookup", {
                    key: "propertyLookup",
                    attrs: {
                      id: "propertyLookup",
                      lookupFormatError: _vm.postcodeFormatError,
                      lookupLabel: _vm.lookupPostcodeLabel,
                      searchButton: _vm.searchButtonLabel,
                      customersOnly: _vm.customersOnly,
                      notListedError: _vm.postcodeNotListed,
                      notAllowedError: _vm.postcodeNotAllowed
                    },
                    on: {
                      selectedAddress: _vm.updateAddress,
                      locationValid: _vm.setLocationValid,
                      onSubmit: _vm.propertyLookupSubmit
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("action-buttons", {
        attrs: {
          showPrev: false,
          nextLabel: _vm.continueButtonText,
          nextDisabled: _vm.nextIsDisabled,
          showNext: true
        },
        on: {
          onNext: function($event) {
            return _vm.$emit("stepChange", 1)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-784ad126", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-784ad126","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/ProblemLocation.vue
// module id = 754
// module chunks = 0